import OT from "@opentok/client";
import * as Sentry from "@sentry/vue";

import { hasValue } from "@/Utils/Objects";
import { waitFor } from "@/Utils/Promises";
import { isApp } from "@/Utils/Ionic";
import { log, danger } from "@/Utils/Debug";

export const hasPermissions = async (): Promise<boolean> => {
  try {
    if (
      !hasValue(navigator) ||
      !hasValue(navigator.mediaDevices) ||
      !hasValue(navigator.mediaDevices.dispatchEvent)
    ) {
      return Promise.resolve(false);
    }
    // get audio and video permissions then stop the tracks
    const permissions = await navigator.mediaDevices
      .getUserMedia({ audio: true, video: { facingMode: "user" } })
      .then(async (mediaStream) => {
        mediaStream.getTracks().forEach((track) => {
          track.stop();
        });

        return true;
      })
      .catch(() => {
        return false;
      });

    if (permissions) {
      log("Has permisions for videocall");
    } else {
      log("Does not have permisions for videocall");
    }

    // The devicechange event is not fired after permissions are granted, so we fire it
    // ourselves to update the useDevices hook. The 100 ms delay is needed so that device labels are available
    // when the useDevices hook updates.
    await waitFor(0.2);

    navigator.mediaDevices.dispatchEvent(new Event("devicechange"));

    return permissions;
  } catch (e) {
    danger("Permisions Videocall error", e);

    Sentry.captureException(e);

    return Promise.resolve(false);
  }
};

export const hasSupport = (): boolean => {
  if (isApp()) return true;

  const hasRequirements = OT.checkSystemRequirements() === 1;

  if (hasRequirements) {
    log("Has support for videocall");
  } else {
    log("Does not have support for videocall");
  }

  return hasRequirements;
};
